import {
  EntityStatusInput,
  RemoveFormItem,
  UserOptionLabel,
} from "@/components";
import { DEFAULT_DEBOUNCE_TIME } from "@/config";
import { selectFilterHelper } from "@/helpers";
import { optionFieldType, optionType, refType } from "@/propTypes";
import { useSuggestUsersQuery } from "@/services";
import { Form, Select, Space, Spin } from "antd";
import debounce from "lodash.debounce";
import { arrayOf, func } from "prop-types";
import { useState } from "react";
import { useIntl } from "react-intl";

const { Option } = Select;

export const OptionEditUserValue = ({
  field,
  remove,
  availableDependantValues,
  form,
}) => {
  const intl = useIntl();

  const [value, setValue] = useState();
  const [query, setQuery] = useState();

  const { data: userSuggestions, isFetching } = useSuggestUsersQuery(
    { query },
    { skip: !query }
  );

  const onSearch = debounce((value) => {
    setQuery(value);
  }, DEFAULT_DEBOUNCE_TIME);

  const handleChange = (value) => {
    setValue(value);
  };

  const handleSelect = (_, option) => {
    const options = form.current.getFieldValue("values");

    if (options[field.key]) {
      if (!options[field.key].Label) options[field.key].Label = {};
      options[field.key].Label.fallback = option.label;
      form.current.setFieldsValue({ values: options });
    }
  };

  return (
    <Space key={field.key} style={{ display: "flex", alignItems: "center" }}>
      <Form.Item
        isListField={field.isListField}
        name={[field.name, "userId"]}
        key={[field.fieldKey, "userId"]}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.optionUserRequired",
            }),
          },
        ]}
      >
        <Select
          data-test-id={`option-edit-user-value-${value}`}
          showSearch
          defaultActiveFirstOption={false}
          placeholder={intl.formatMessage({
            id: "newFormField.optionUserPlaceholder",
          })}
          filterOption={false}
          allowClear
          onSearch={onSearch}
          optionLabelProp="label"
          value={value}
          onChange={handleChange}
          onSelect={handleSelect}
          notFoundContent={isFetching ? <Spin size="small" /> : null}
          style={{ minWidth: "200px" }}
        >
          {userSuggestions?.map(
            ({
              document: {
                id,
                displayName,
                department,
                email,
                jobTitle,
              },
            }) => (
              <Option key={id} label={displayName}>
                <UserOptionLabel
                  displayName={displayName}
                  department={department}
                  email={email}
                  jobTitle={jobTitle}
                />
              </Option>
            )
          )}
        </Select>
      </Form.Item>
      <Form.Item isListField={field.isListField} name={[field.name, "dependsOnPropertyValues"]}>
        <Select
          mode="multiple"
          style={{ maxWidth: 500, minWidth: 300 }}
          allowClear
          placeholder={intl.formatMessage({
            id: "newFormField.dependentValuesPlaceholder",
          })}
          filterOption={selectFilterHelper}
        >
          {availableDependantValues.map(({ value, text }) => (
            <Select.Option value={value} key={value}>
              {text}
            </Select.Option>
          ))}
        </Select>
      </Form.Item>

      <EntityStatusInput
        parentComponent="option-edit-user-value"
        field={field}
      />

      <RemoveFormItem
        parentComponent="option-edit-user-value"
        uniqueId={value}
        remove={() => remove(field.name)}
      />
    </Space>
  );
};

OptionEditUserValue.propTypes = {
  form: refType.isRequired,
  remove: func.isRequired,
  field: optionFieldType.isRequired,
  availableDependantValues: arrayOf(optionType).isRequired,
};
